<template>
  <div class="home" id="wtjsb">
    
    <!-- <div id="fullpage-wp" class="fullpage-wp"> -->
      <ModelOne @showVideo="showVideoVisible = true"></ModelOne>
      <ModelTwo></ModelTwo>
      <ModelThree></ModelThree>
      <ModelFour></ModelFour>
      <ModelFive></ModelFive>
      <ModelSix @toTop="moveToTop"></ModelSix>
    <!-- </div> -->
    <div v-if="showVideoVisible">
      <video-player
        :visible.sync="showVideoVisible"
        :videoSrc="$theme ? '/video/cn.mp4' : '/video/eng.mp4'"
      ></video-player>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/video-player/Index.vue';
import ModelOne from "./components/model-one/Index.vue";
import ModelTwo from "./components/model-two/Index.vue";
import ModelThree from "./components/model-three/Index.vue";
import ModelFour from "./components/model-four/Index.vue";
import ModelFive from "./components/model-five/Index.vue";
import ModelSix from "./components/model-six/Index.vue";
export default {
  name: "Home",
  components: {
    ModelOne,
    ModelTwo,
    ModelThree,
    ModelFour,
    ModelFive,
    ModelSix,
    VideoPlayer,
  },
  data() {
    return {
      showHeader: true,
      showVideoVisible: false,
      opts: {
        start: 0,
        dir: "v",
        duration: 500,
        beforeChange: function (currentSlideEl, currenIndex, nextIndex) {},
        afterChange:  (currentSlideEl, currenIndex, nextIndex)=>{
          if(currenIndex==5) {
            this.showHeader = false;
          }else {
            this.showHeader = true;
          }
        },
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    var element = document.getElementById("wtjsb");
    
    
    element.addEventListener("scroll", () => {
      var scrollTop = element.scrollTop;
      
      if (scrollTop>0) {
        // 页面已滚动到底部
        this.$bus.$emit("change-show-header", false);
      } else {
        this.$bus.$emit("change-show-header", true);
      }
      
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_HOME_ACTIVE", 1);
    next();
  },
  methods: {
    moveToTop() {
      this.$refs.example.$fullpage.moveTo(0,true ,true);
      this.showHeader = true; //Move to the next page
    },
  },
  watch: {
    showHeader(val) {
      this.$bus.$emit("change-show-header", val);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./Index.scss";
</style>
